var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackerMooSuit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 135,
    viewBox: "0 0 206 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9434 89.8087H67.3429V71.0221H59.998L40.9434 89.8087Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3421 89.8086H43.1377V133.259H67.3421V89.8086Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3429 126.342H40.9434V133.265H67.3429V126.342Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.676 133.259H67.3418V56.428L87.0154 39.9514L106.683 56.428V133.259H106.676Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.227 39.9514L144.346 56.428V133.265H106.677V56.428L87.0098 39.9514H118.227Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.405 126.342H106.677V133.265H114.405V126.342Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.334 126.342H66.0859V133.265H103.334V126.342Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0159 34.0806L60.5781 56.4216H67.3487L87.0223 39.945L106.69 56.4216H113.454L87.0159 34.0806Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.679 34.0806L151.11 56.4216H113.441L87.0098 34.0806H124.679Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.683 126.342H94.0928V133.265H106.683V126.342Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4872 61.8394H79.8184V84.7866H93.4872V61.8394Z",
    fill: "#FEF6E9",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4879 74.7104H70.7002V85.7501H93.4879V74.7104Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0633 74.7104H91.2207V85.7501H99.0633V74.7104Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93.487 83.1785H69.3018V85.7501H93.487V83.1785Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9765 83.1785H89.9961V85.7501H99.9765V83.1785Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1016 76.7206V81.3279",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6826 76.7206V81.3279",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2705 76.7206V81.3279",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8525 76.7206V81.3279",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M130.914 74.5892L114.425 89.8087H138.629L155.119 74.5892H130.914Z",
    fill: "#A2B7FA",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138.629 89.8086H114.425V133.259H138.629V89.8086Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M138.629 126.342H114.412V133.265H138.629V126.342Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.118 74.5892L170.906 89.8087V133.259H138.629V89.8087L155.118 74.5892Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.458 61.7308H113.091V65.3873H139.458V61.7308Z",
    fill: "#FEF6E9",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M138.629 89.8087H133.377L155.118 69.9819L175.404 89.8087H170.899L155.118 74.5892L138.629 89.8087Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.72 89.8087L130.461 69.9819H155.118L133.377 89.8087H108.72Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M173.401 126.342H137.353V133.265H173.401V126.342Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M162.641 98.9211H147.938V116.004H162.641V98.9211Z",
    fill: "#FEF6E9",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M155.29 98.9211V116.004",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M162.641 107.459H147.938",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M163.751 116.004H146.815V118.684H163.751V116.004Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M147.167 116.336L162.731 116.999L163.414 118.34V116.336H147.167Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M146.612 115.749L145.521 116.974V119.597H163.49L164.007 118.984L163.516 118.678L146.573 118.429L146.612 115.749Z",
    fill: "#282750"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M132.93 98.9211H119.542V116.004H132.93V98.9211Z",
    fill: "#FEF6E9",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M126.229 98.9211V116.004",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M132.918 107.459H119.536",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M133.938 116.004H118.515V118.684H133.938V116.004Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M118.84 116.336L133.006 116.999L133.625 118.34V116.336H118.84Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M118.337 115.749L117.335 116.974V119.597H133.703L134.175 118.984L133.729 118.678L118.299 118.429L118.337 115.749Z",
    fill: "#282750"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4163 98.9211H49.0283V116.004H62.4163V98.9211Z",
    fill: "#FEF6E9",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7158 98.9211V116.004",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4163 107.459H49.0283",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4373 116.004H48.0137V118.684H63.4373V116.004Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M48.333 116.336L62.4995 116.999L63.1185 118.34V116.336H48.333Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8226 115.749L46.8271 116.974V119.597H63.1889L63.6611 118.984L63.2144 118.678L47.7843 118.429L47.8226 115.749Z",
    fill: "#282750"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0868 98.8319H80.418V122.634H94.0868V98.8319Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7129 116.47H89.8052",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1922 122.724H78.223V126.342H74.2538V129.807H70.291V133.265H74.2538H78.223H94.0934V122.724H82.1922Z",
    fill: "#FFB49E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1922 122.724H78.223V126.342H74.2538V129.807H70.291V133.265H74.2538H78.223H94.0934V122.724H82.1922V122.724Z",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2529 129.807H86.1541",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2227 126.342H90.1238",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1244 122.724V126.342H86.1552V129.807H82.1924V133.265H86.1552H90.1244H94.0936V122.724H90.1244Z",
    fill: "#FEF6EB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1244 122.724V126.342H86.1552V129.807H82.1924V133.265H86.1552H90.1244H94.0936V122.724H90.1244V122.724Z",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2912 129.462L70.3869 133.099H68.6895L69.6594 129.443H70.1635",
    fill: "#282750"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2536 126.176L74.3493 129.813H72.6455L73.5006 126.157H74.126",
    fill: "#282750"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3253 122.392L78.4274 126.023H76.7236L77.5787 122.379H78.2041",
    fill: "#282750"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0117 101.997H83.5137V108.716H91.0117V101.997Z",
    fill: "white",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2588 108.716V101.997",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5137 105.354H91.0053",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3578 85.9224L97.7688 86.8796H68.3828V84.7802H69.1613V85.7501L99.3578 85.9224Z",
    fill: "#282750"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M150.173 56.0259L124.577 34.4379H88.1592L124.258 35.21L150.173 56.0259Z",
    fill: "#FEF6E9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M172.998 132.908L172.104 127.484L172.998 126.686V132.908Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M172.999 126.693V127.49L140.212 126.693H172.999Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4043 83.5167L98.8978 84.1868L99.5806 85.4056V85.5268V83.5167H90.4043Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5986 75.0614L98.0182 75.7251L98.701 82.7892V75.0614H91.5986Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8184 72.0814C79.8184 72.0814 83.9917 71.2773 85.4339 61.8394H79.8184V72.0814Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4868 72.0814C93.4868 72.0814 88.6561 71.0923 87.8457 61.8394H93.4868V72.0814Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M170.904 91.1424H169.877L154.766 76.2803L138.634 90.8999H107.863L108.852 89.9364H138.628L154.989 74.6276L170.777 89.8024L170.904 91.1424Z",
    fill: "#282750"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M144.346 58.2211H106.677L87.0032 41.7063L67.3359 57.9531V56.1153L87.0032 40.1812L106.677 56.4216H144.346V58.2211Z",
    fill: "#282750"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6562 133.259V126.342H66.2069L66.392 89.8088L65.2816 70.8052H67.3428V126.342H66.0857V133.266H64.6562V133.259Z",
    fill: "#282750"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M174.511 89.3428L155.118 70.4541L139.101 85.0737L155.118 71.105L173.521 89.3364H174.511V89.3428Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M120.697 61.7308V65.3873",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M132.395 61.7308V65.3873",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M143.995 58.2211H143.389V69.6117H143.995V58.2211Z",
    fill: "#FEF6E9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M170.549 91.1423H169.942V125.876H170.549V91.1423Z",
    fill: "#FEF6E9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0105 55.4772C89.0792 55.4772 90.7563 53.8001 90.7563 51.7313C90.7563 49.6625 89.0792 47.9855 87.0105 47.9855C84.9417 47.9855 83.2646 49.6625 83.2646 51.7313C83.2646 53.8001 84.9417 55.4772 87.0105 55.4772Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M179.561 96.6048V97.1048H179.752L179.894 96.9774L179.561 96.6048ZM185.266 91.4998V90.9998H185.075L184.933 91.1271L185.266 91.4998ZM192.873 91.4998L193.224 91.1434L193.078 90.9998H192.873V91.4998ZM198.06 96.6048H198.56C198.56 96.4708 198.506 96.3425 198.411 96.2485L198.06 96.6048ZM196.504 97.6258V97.1258H196.004V97.6258H196.504ZM196.504 101.71H196.004V102.21H196.504V101.71ZM198.06 97.6258V98.1258H198.56V97.6258H198.06ZM170.743 97.1048H179.561V96.1048H170.743V97.1048ZM179.894 96.9774L185.6 91.8724L184.933 91.1271L179.227 96.2322L179.894 96.9774ZM185.266 91.9998H192.873V90.9998H185.266V91.9998ZM192.523 91.8561L197.71 96.9612L198.411 96.2485L193.224 91.1434L192.523 91.8561ZM196.004 97.6258V101.71H197.004V97.6258H196.004ZM196.504 102.21H205.84V101.21H196.504V102.21ZM197.56 96.6048V97.6258H198.56V96.6048H197.56ZM198.06 97.1258H196.504V98.1258H198.06V97.1258Z",
    fill: "#282750"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M152.953 9.81874H194.355C194.355 9.81874 190.617 0.885595 182.878 5.99794C180.332 0.347453 170.441 -1.8948 164.595 5.99794C160.447 -0.22208 151.98 4.49114 152.953 9.81874Z",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M23.335 133.616H188.292",
    stroke: "#282750"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1 71.0796C4.57354 66.7403 30.9922 34.3869 30.9922 34.3869L43.7549 47.4687L79.4903 3.75659L106.93 34.3869",
    stroke: "#282750"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M203.288 58.3168L201.08 56.1091C199.128 54.1565 195.962 54.1565 194.009 56.1091L187.973 62.1456L163.206 37.379C158.911 33.0832 151.946 33.0832 147.65 37.379L138.837 46.1923",
    stroke: "#282750"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4092 19.7098L70.7711 22.7632C71.9391 23.5808 73.5254 23.4418 74.5335 22.4337V22.4337C75.5521 21.4152 77.1589 21.2853 78.3278 22.1269L81.5165 24.4227C83.1079 25.5686 85.2954 25.3917 86.6821 24.005L89.0629 21.6242C89.5915 21.0956 90.4486 21.0956 90.9773 21.6242V21.6242C91.5059 22.1529 92.363 22.1529 92.8917 21.6242L94.1679 20.348",
    stroke: "#282750"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6963 44.9959L23.9103 46.1924C25.7058 47.962 28.5895 47.962 30.385 46.1924L32.206 44.3976C32.9915 43.6234 34.2532 43.6234 35.0387 44.3976V44.3976C35.8242 45.1718 37.0859 45.1718 37.8714 44.3976L39.2877 43.0017",
    stroke: "#282750"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M161.171 35.3441L159.416 37.099C158.447 38.0682 156.875 38.0682 155.906 37.099V37.099C154.937 36.1298 153.366 36.1298 152.397 37.099L152.237 37.2585C151.18 38.3158 149.466 38.3158 148.408 37.2585L148.089 36.9394",
    stroke: "#282750"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2599 18.1145H38.0115C38.0115 18.1145 35.5963 12.3718 30.5957 15.6583C28.951 12.0258 22.5596 10.5844 18.7824 15.6583C16.1018 11.6597 10.6309 14.6896 11.2599 18.1145Z",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9043 47.4685L52.5191 56.0833",
    stroke: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7093 66.0892H41.6927L37.1811 70.1988V62.7837H31.5464V75.3421L27.7559 78.8008V81.4746H30.4233V86.2733",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5038 85.9734H10.7217",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackerMooSuit);
export default __webpack_public_path__ + "static/media/tracker-moo-suit.272cf5bd21c5523cbc16cdf42adb2bbe.svg";
export { ForwardRef as ReactComponent };